"use client";

import { c as _c } from "react/compiler-runtime";
import { getConnectionProfileIndicator } from "@/components/auth/connection-state-indicator";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import { DEFAULT_CONNECTED_PROFILE_FALLBACK_PFP } from "@/constants/constants";
import { formatAddress } from "@/helpers/Helpers";
import { useIdentity } from "@/hooks/useIdentity";
interface ConnectedAccountItem {
  readonly address: string;
  readonly isActive: boolean;
  readonly isConnected: boolean;
}
function ConnectedAccountRow(t0) {
  const $ = _c(43);
  const {
    account,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== account.address) {
    t1 = {
      handleOrWallet: account.address,
      initialProfile: null
    };
    $[0] = account.address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile,
    isLoading: isProfileLoading
  } = useIdentity(t1);
  let t2;
  if ($[2] !== account.isConnected) {
    t2 = getConnectionProfileIndicator({
      isAuthenticated: true,
      isConnected: account.isConnected
    });
    $[2] = account.isConnected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const connectionIndicator = t2;
  let t3;
  if ($[4] !== profile) {
    t3 = profile?.pfp ? resolveIpfsUrlSync(profile.pfp) : null;
    $[4] = profile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const resolvedPfp = t3;
  const shouldShowFallbackPfp = !isProfileLoading && !resolvedPfp;
  const avatarSrc = resolvedPfp ?? (shouldShowFallbackPfp ? DEFAULT_CONNECTED_PROFILE_FALLBACK_PFP : null);
  let t4;
  if ($[6] !== account.address || $[7] !== profile?.handle) {
    t4 = profile?.handle ?? `${account.address.slice(0, 6)}...${account.address.slice(-4)}`;
    $[6] = account.address;
    $[7] = profile?.handle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const label = t4;
  let t5;
  if ($[9] !== account.address) {
    t5 = formatAddress(account.address);
    $[9] = account.address;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const walletLabel = t5;
  let t6;
  if ($[11] !== account.address || $[12] !== onSelect) {
    t6 = () => onSelect(account.address);
    $[11] = account.address;
    $[12] = onSelect;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `tw-group tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-none tw-px-3 tw-py-2.5 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${account.isActive ? "tw-bg-iron-700" : "tw-bg-transparent hover:tw-bg-iron-700"}`;
  const t8 = `Switch to ${label} (${walletLabel})`;
  const t9 = `tw-relative tw-size-8 tw-flex-none tw-overflow-hidden tw-rounded-lg ${connectionIndicator.avatarClassName}`;
  let t10;
  if ($[14] !== avatarSrc || $[15] !== label || $[16] !== resolvedPfp) {
    t10 = avatarSrc && <img src={avatarSrc} alt={label} className={`tw-absolute tw-inset-0 tw-block tw-h-full tw-w-full tw-rounded-lg tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out ${resolvedPfp ? "tw-object-contain" : "tw-object-cover tw-grayscale"}`} />;
    $[14] = avatarSrc;
    $[15] = label;
    $[16] = resolvedPfp;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== connectionIndicator.overlayClassName) {
    t11 = connectionIndicator.overlayClassName && <div className={`tw-pointer-events-none tw-absolute tw-inset-0 tw-rounded-lg ${connectionIndicator.overlayClassName}`} />;
    $[18] = connectionIndicator.overlayClassName;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== connectionIndicator.title || $[21] !== t10 || $[22] !== t11 || $[23] !== t9) {
    t12 = <div className={t9} title={connectionIndicator.title}>{t10}{t11}</div>;
    $[20] = connectionIndicator.title;
    $[21] = t10;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== label) {
    t13 = <span className="tw-w-full tw-truncate tw-text-md tw-font-medium tw-text-white">{label}</span>;
    $[25] = label;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== walletLabel) {
    t14 = <span className="tw-w-full tw-truncate tw-text-[11px] tw-font-medium tw-text-iron-400">{walletLabel}</span>;
    $[27] = walletLabel;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-leading-tight">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== account.isActive) {
    t16 = account.isActive && <svg className="tw-ml-2 tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[32] = account.isActive;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">{t15}{t16}</div>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t12 || $[38] !== t17 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t18 = <button type="button" onClick={t6} className={t7} aria-label={t8}>{t12}{t17}</button>;
    $[37] = t12;
    $[38] = t17;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
}
export default function HeaderUserConnectedAccounts(t0) {
  const $ = _c(12);
  const {
    accounts,
    onSelectAccount,
    canAddAccount,
    onAddAccount
  } = t0;
  if (accounts.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-m-0 tw-px-3 tw-pt-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-500">Connected Profiles</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== accounts || $[2] !== onSelectAccount) {
    let t3;
    if ($[4] !== onSelectAccount) {
      t3 = account => <ConnectedAccountRow key={account.address.toLowerCase()} account={account} onSelect={onSelectAccount} />;
      $[4] = onSelectAccount;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = accounts.map(t3);
    $[1] = accounts;
    $[2] = onSelectAccount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== canAddAccount || $[7] !== onAddAccount) {
    t3 = canAddAccount && <button type="button" onClick={onAddAccount} className="tw-group tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-none tw-bg-transparent tw-px-3 tw-py-2.5 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-700 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400" aria-label="Add account"><div className="tw-flex tw-h-6 tw-w-6 tw-flex-none tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-700 tw-text-iron-200 tw-ring-1 tw-ring-iron-500">+</div><div className="tw-inline-flex tw-w-full tw-items-center tw-justify-between tw-truncate"><span className="tw-text-md tw-font-medium tw-text-white">Add</span><span className="tw-ml-2 tw-h-5 tw-w-5" aria-hidden="true" /></div></button>;
    $[6] = canAddAccount;
    $[7] = onAddAccount;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t1}<div className="tw-flex tw-flex-col tw-gap-y-1">{t2}{t3}</div></div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}